<!-- Disable the warning since the component will always be a HTML element, not an actual component -->
<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
    <component
        :is="props.tagType"
        v-html="html"
    />
</template>
<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        /**
         * The text to display
         */
        text: string;

        /**
         * Regexp to match the part of the text to mark
         *
         * If a string is provided, it will be converted to a regexp
         *
         * A new RegExp object is always created so any state in the provided RegExp will be lost
         */
        markPart: RegExp | string | undefined;

        /**
         * The type of the tag that wraps the text and mark tag
         * Defaults to span
         */
        tagType?: keyof HTMLElementTagNameMap;
    }>(),
    {
        tagType: 'span',
    },
);

const html = computed(() => {
    if (!props.markPart) {
        return props.text;
    }

    const regExp = new RegExp(props.markPart);
    const marked = props.text.replace(regExp, (match) => `<mark class="p-0">${match}</mark>`);
    return marked;
});
</script>
